<template>
	<div id="alignmentDialog">
		<el-dialog  title="工单查看"  :visible.sync="isShowDialog" :width="W?'70%':'80%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-table border :data="kittingList" stripe style="width: 100%;margin-bottom:10px;margin-top:10px" class="marterial-table">
                
                <el-table-column label="物料编码" prop="materialCode" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料名称" prop="materialName" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" prop="specification" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="材质" prop="materialQualityName" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="计划数" prop="splitCount" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="完成数" prop="finishCount" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="未完成数" prop="specification" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{(scope.row.splitCount - scope.row.finishCount)}}
                    </template>
                </el-table-column>
                
            </el-table>
            <el-table border :data="kittingList[0].nextList" stripe style="width: 100%;margin-bottom:10px;margin-top:30px" class="marterial-table">
                
                <el-table-column label="物料编码" prop="materialCode" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料名称" prop="materialName" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" prop="specification" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="材质" prop="materialQualityName" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="装配数量" prop="amount" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="生产类型" prop="productionType" :formatter="parseProductionType" min-width="70"></el-table-column>
                <el-table-column label="需求数量" prop="demandCount" min-width="80"></el-table-column>
                <el-table-column label="已领" prop="receivedCount" min-width="80"></el-table-column>
                <el-table-column label="未领" prop="unclaimedCount" min-width="80"> </el-table-column>
                <el-table-column label="库存" prop="inventoryCount" min-width="80"></el-table-column>
                <el-table-column label="领取中" prop="receivingCount" min-width="80"></el-table-column>
                <el-table-column label="退料中" prop="returningMaterialsCount"  min-width="80"></el-table-column>
            </el-table>

			<div style="text-align: center;">
                <el-button   @click="cancelAddDialog">取 消</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils';

export default {
	name: 'MaterialAlignment',
	props: {
        isShow: Boolean,
        splitData:Object,
	},
	data() {
		return {
            info:{},
            statuOption:[  //0-未齐套 ｜ 1-部分齐套 ｜ 2-已齐套
                {value:0,label:'未齐套'},
                {value:1,label:'部分齐套'},
                {value:2,label:'已齐套'}
            ],
            materialStatusOption:[
                {value:0,label:'未齐套'},
                {value:1,label:'已齐套'},
            ],
            productionOption:[
                { id: 1, label: "自产" },
                { id: 2, label: "外协" },
                { id: 3, label: "自产+外协" },
                { id: 4, label: "外购" }
            ],
            isShowDialog: false,
            itemList:[],
            kittingList:[{nextList:[]}],
            W:true,
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        mathCeill(num){
            if(num==0){
                return 0
            }
            return Math.ceil(num*100)/100
        },
        parseProductionType(rowData) {
            if (rowData.productionType) {
                let find = this.productionOption.find(item => item.id == rowData.productionType)
                return find.label
            }
        },
        async loadDetailBySplitId(splitId){
            let {data:{dataList,alignmentStatus},code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/productionTask/getMaterialAlignment',type:'sync',params: {splitId}})
            if(code==0){
                this.itemList = dataList
                this.info.alignmentStatus = (this.statuOption.find(item=>item.value==alignmentStatus)||{}).label
               
            }else{
                this.$message.error(msg||message)
            }
        },

        async loadDetailBySplitId(splitId){
          
          let {code,data,message,msg}= await this.$RequestUtil.getAsync({url:'/api/productionTask/getKittingInfo',type:'sync',params: {  splitId},});
          if(code == 0){    
                this.kittingList = [{...data}]
           }else{
               this.$message.error(message||msg)
           }
       },
       
        parseStatus(row){
            return (this.materialStatusOption.find(item=>item.value==row.materialStatus)||{}).label
        },
        
		cancelAddDialog() {
            this.itemList = []
            this.isShowDialog = false
            this.$parent.showAlignment = false
        },
	},
	watch: {
		"isShow": async function (newVal, oldVal) {
            
            if(newVal){
                this.info = CommonUtils.cloneObj(this.splitData)
                await this.loadDetailBySplitId(this.info.id)
            }
            this.isShowDialog = this.isShow;
		},
    },
    filters:{
        formatteMaterialName(value) {
            let str = ''
            switch (value) {
                case 0:
                    str = '产品'
                    break;
                case 1:
                    str = '零件'
                    break;
                case 2:
                    str = '原材料'
                    break;
                default:
                    str = '未知类型'
                    break;
            }
            return str
        },
    },
}
</script>
<style scoped>
    
    .title {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
        display: inline-block;
        text-align: right;
        width: 70px;
    }

    .value {
        display: inline-block;
        font-size: 14px;
		color: #606266;
    }

    @media screen and (min-width: 1300px) and (max-width: 1930px){
    
    }
</style>


<style>


</style>


// WEBPACK FOOTER //
// src/views/order/ProductionTask/MaterialAlignment.vue